import { formatQty, type ProcurementListItemDTO } from '@wf/shared'
import { useAdvanceProcurement } from './useProcurement'

// Vorwärts/zurück je Quelle. restock endet bei 'delivered' (Wareneingang → Lager, danach erledigt);
// order_oneoff durchläuft den vollen Prozess bis 'installed' (Verbaut markiert den Einbau im Auftrag).
const FORWARD_RESTOCK: Record<string, { to: string; label: string }> = {
  needed: { to: 'ordered', label: 'Bestellen' },
  ordered: { to: 'delivered', label: 'Geliefert' },
}
const FORWARD_ONEOFF: Record<string, { to: string; label: string }> = {
  needed: { to: 'ordered', label: 'Bestellen' },
  ordered: { to: 'delivered', label: 'Geliefert' },
  delivered: { to: 'installed', label: 'Verbaut' },
}
const BACK_RESTOCK: Record<string, string> = { ordered: 'needed' }
const BACK_ONEOFF: Record<string, string> = { ordered: 'needed', delivered: 'ordered', installed: 'delivered' }

/**
 * Eine Karte im Einkauf-Board. Nachschub (restock) zeigt nur Bezeichnung/SNR/Menge; ein Einmal-Teil
 * (order_oneoff) zusätzlich Fahrzeug + Auftrags-Kontext. Die Schaltflächen schieben den Eintrag je nach
 * Quelle eine Stufe weiter oder zurück; der Server erzwingt die erlaubten Übergänge.
 */
export function ProcurementCard({ item }: { item: ProcurementListItemDTO }) {
  const advance = useAdvanceProcurement()
  const isRestock = item.source === 'restock'
  const forward = (isRestock ? FORWARD_RESTOCK : FORWARD_ONEOFF)[item.status]
  const back = (isRestock ? BACK_RESTOCK : BACK_ONEOFF)[item.status]

  return (
    <div className="wf-card wf-card--static">
      <div>
        <div className="wf-card__title wf-partcard__name">{item.name}</div>
        {item.partNumber ? <div className="wf-card__meta wf-tnum">{item.partNumber}</div> : null}
      </div>
      <div className="wf-card__row wf-partcard__row">
        {isRestock ? (
          <span className="wf-pill">Nachschub</span>
        ) : (
          <span className="wf-plate">
            <span className="wf-plate__eu">D</span>
            <span className="wf-plate__nr">{item.plate ?? '—'}</span>
          </span>
        )}
        <span className="wf-partcard__ctx">
          {isRestock ? `${formatQty(item.quantityTenths)}×` : `#${item.orderNr ?? item.orderId} · ${formatQty(item.quantityTenths)}×`}
        </span>
        <div className="wf-partcard__actions">
          {back ? (
            <button
              type="button"
              className="wf-btn wf-btn--ghost wf-btn--sm"
              aria-label={`${item.name}: einen Schritt zurück`}
              disabled={advance.isPending}
              onClick={() => advance.mutate({ id: item.id, status: back })}
            >
              ↩
            </button>
          ) : null}
          {forward ? (
            <button
              type="button"
              className="wf-btn wf-btn--ghost wf-btn--sm"
              disabled={advance.isPending}
              onClick={() => advance.mutate({ id: item.id, status: forward.to })}
            >
              {forward.label}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  )
}
